import { computed, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useClientStore } from '@/stores/ClientStore'
import { useAuthenticationStore } from '@/stores/AuthenticationStore'
import { useConsent } from '@/vendors/consent'
import { useTrackingSession, useTrackingUser } from '@/vendors/tracking'
import mixpanel from 'mixpanel-browser'

window.mixpanel = mixpanel

export const createMixpanel = {
  install: () => {
    const { getClient } = useClientStore()
    const { authUser } = storeToRefs(useAuthenticationStore())
    const { isVendorAllowed } = useConsent()

    const { client } = getClient()

    const token = process.env.VUE_APP_MIXPANEL_TOKEN

    try {
      mixpanel.init(token, {
        api_host: 'https://api-eu.mixpanel.com',
        persistence: 'cookie',
        batch_requests: true,
        cross_subdomain_cookie: !/koalect.com|koalect.dev/.exec(window.location.host),
        secure_cookie: process.env.NODE_ENV !== 'development',
        opt_out_tracking_by_default: true,
        cookie_expiration: 180
      })
    } catch (e) {
      throw e
    }

    const isAllowed = computed(() => isVendorAllowed('mixpanel'))

    watch(isAllowed, () => {
      const { trackSessionStarted } = useTrackingSession()
      const { trackUser, trackUserClient } = useTrackingUser()

      if (isAllowed.value) {
        mixpanel.opt_in_tracking()
        mixpanel.register_once(client.value.to_mixpanel)

        if (authUser.value) {
          trackSessionStarted({ user: authUser.value })
          trackUser({ user: authUser.value })
          trackUserClient({ client: client.value })
        }
      } else {
        mixpanel.reset()
        mixpanel.opt_out_tracking()
      }
    })
  }
}

export const useMixpanel = () => mixpanel